import styles from './settingsPage.module.css';

import Button from '../../components/ui/button/Button';

import supabase from '../../utils/supabase';
import getProfileSettings from '../../utils/getProfileSettings';
import { useParams } from 'react-router-dom';
import { useEffect, useState } from 'react';

export default function SettingsPage() {
  const { id } = useParams();
  const [profileSettings, setProfileSettings] = useState(getProfileSettings());

  function saveProfileSettings() {
    localStorage.setItem('profileSettings', JSON.stringify(profileSettings));
  }

  return (
    <section className={styles.settingsPage}>
      <div className={`container ${styles.settingsPageContainer}`}>
        <h2 className={styles.settingsPageTitle}>Налаштування профілю</h2>

        <ul className={`list ${styles.settingsList}`}>
          <li className={styles.settingsItem}>
            <h3>Спосіб відображення</h3>
            <div className={styles.displayModeSetting}>
              <input
                className={`visually-hidden ${styles.displayModeInput}`}
                onChange={e => {
                  setProfileSettings({
                    ...profileSettings,
                    displayMode: e.target.value,
                  });
                }}
                checked={profileSettings.displayMode === 'grid'}
                type="radio"
                name="displayMode"
                value="grid"
                id="settings-grid"
              />
              <label
                htmlFor="settings-grid"
                className={styles.displayModeLabel}
              >
                <span
                  className={`${styles.gridVisualisationIcon} ${styles.visualisationIcon}`}
                >
                  <span className={styles.iconPart}></span>
                  <span className={styles.iconPart}></span>
                  <span className={styles.iconPart}></span>
                  <span className={styles.iconPart}></span>
                  <span className={styles.iconPart}></span>
                  <span className={styles.iconPart}></span>
                </span>
                Сітка
              </label>
              <input
                className={styles.displayModeInput}
                onChange={e => {
                  setProfileSettings({
                    ...profileSettings,
                    displayMode: e.target.value,
                  });
                }}
                checked={profileSettings.displayMode === 'list'}
                type="radio"
                name="displayMode"
                value="list"
                id="settings-list"
              />
              <label
                htmlFor="settings-list"
                className={styles.displayModeLabel}
              >
                <span
                  className={`${styles.listVisualisationIcon} ${styles.visualisationIcon}`}
                >
                  <span className={styles.iconPart}></span>
                  <span className={styles.iconPart}></span>
                  <span className={styles.iconPart}></span>
                </span>
                Список
              </label>
            </div>
          </li>
        </ul>

        <Button onClick={saveProfileSettings}>Зберігти</Button>
      </div>
    </section>
  );
}
